import styles from "./SidebarLayout.module.css";
import { HEADER_HEIGHT } from "./constants";
import type { PaneConfig, SplitPaneProps } from "@gfazioli/mantine-split-pane";
import { Split } from "@gfazioli/mantine-split-pane";
import { Box } from "@mantine/core";
import { type ReactNode, useMemo } from "react";

export default function SidebarLayout({
  showSidebar,
  children,
  sidebar,
  sidebarSplitPaneProps
}: {
  showSidebar: boolean;
  children: ReactNode;
  sidebar: ReactNode;
  sidebarSplitPaneProps?: Partial<SplitPaneProps>;
}) {
  const panes = useMemo(() => {
    const config: PaneConfig[] = [
      {
        id: "main",
        content: children,
        grow: true
      }
    ];
    if (showSidebar) {
      config.push({
        id: "sidebar",
        initialWidth: "25vw",
        minWidth: 400,
        maxWidth: 1000,
        content: (
          <Box w="100%" h="100%" p={5} className={styles.sidebarContent}>
            {sidebar}
          </Box>
        ),
        style: {
          border: "solid 1px var(--mantine-color-disabled-border)"
        },
        ...sidebarSplitPaneProps
      });
    }
    return config;
  }, [children, sidebar, showSidebar, sidebarSplitPaneProps]);

  return (
    <Split w="100%" h={`calc(100vh - ${HEADER_HEIGHT}px)`}>
      {Split.Dynamic({ panes })}
    </Split>
  );
}
